import { useState, useEffect } from 'react'

export default function useMobile({ limit = 1025 } = {}) {
	const [isMobile, setMobileBool] = useState(false)

	const updateDimensions = () => {
		setMobileBool(window.innerWidth < limit)
	}

	useEffect(() => {
		updateDimensions()

		window.addEventListener('resize', updateDimensions)
		return () => {
			window.removeEventListener('resize', updateDimensions)
		}
	}, [])

	return isMobile
}
